import tableDirective from './tableDirective';
import tableDirectiveHtml from './tableDirectiveHtml.html';
tableDirective[0].html = tableDirectiveHtml;

export default tableDirective;
